import {
  BrowserRouter,
  Route,
  Routes as ReactRouterRoutes,
} from 'react-router-dom';

import { NewsIndexClient } from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClient';
import type {
  Config,
  NewsIndexClientStandaloneProps,
} from 'hb-react/frontoffice/apps/NewsIndex/types';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';

const NewsIndexClientStandalone = ({
  network,
  page,
}: NewsIndexClientStandaloneProps) => {
  const config: Config = {
    routes: {
      news_url: Routes.network_letters_path({
        format: 'json',
      }),
      categories_url: Routes.network_news_categories_json_path(),
      news_index_url: Routes.news_path(),
    },
    custom: {
      page,
    },
  };

  return (
    <PublicOfficeApp network={network}>
      <BrowserRouter>
        <ReactRouterRoutes>
          <Route
            element={<NewsIndexClient config={config} network={network} />}
            path={'/news/*'}
          />
        </ReactRouterRoutes>
      </BrowserRouter>
    </PublicOfficeApp>
  );
};

export default NewsIndexClientStandalone;
